// A share's (or a guest link's) end date as the dialog takes it: a day
// (YYYY-MM-DD from <input type="date">), sent as the end of that day but
// never past the project's limit. The server refuses a past date
// (`share_expiry_past`), one beyond `max_share_days` / `guest_link_max_days`
// (`share_expiry_too_far`, `guest_link_expiry_too_far`), one past the
// sharer's own access (`share_beyond_own_access`) and any year after 2100.

const DAY = 86_400_000;
// The server's MAX_EXPIRY_YEAR: a later date is a typo.
export const LAST_EXPIRY_DAY = '2100-12-31';

export const dateInput = (iso) => (iso ? new Date(iso).toISOString().slice(0, 10) : '');

/** The chosen day, through its end — but never past the project's limit. */
export const endOfDay = (day, maxDays, now = Date.now()) => {
  if (!day) return null;
  const end = new Date(`${day}T23:59:59`).getTime();
  const cap = maxDays ? now + maxDays * DAY - 60_000 : Infinity;
  return new Date(Math.min(end, cap)).toISOString();
};

/**
 * The days that may be picked: from tomorrow to the earliest of the
 * project's limit (`maxShareDays`), the sharer's own access end and
 * LAST_EXPIRY_DAY. YYYY-MM-DD strings sort as dates.
 */
export function expiryBounds(policy, own, now = new Date()) {
  const min = dateInput(new Date(now.getTime() + DAY).toISOString());
  const ownEnd = own?.expiresAt ? dateInput(own.expiresAt) : '';
  const policyEnd = policy?.maxShareDays ? dateInput(new Date(now.getTime() + policy.maxShareDays * DAY).toISOString()) : '';
  const max = [ownEnd, policyEnd, LAST_EXPIRY_DAY].filter(Boolean).sort((a, b) => a.localeCompare(b))[0];
  return { min, max };
}

/**
 * Why a picked day can't be sent: 'invalid' | 'past' | 'tooFar' | null.
 * A typed date skips the picker's min/max, so they are checked again here.
 */
export function expiryProblem(day, { min, max } = {}) {
  if (!day) return null;
  if (!/^\d{4}-\d{2}-\d{2}$/.test(day) || Number.isNaN(Date.parse(day))) return 'invalid';
  if (min && day < min) return 'past';
  if (max && day > max) return 'tooFar';
  return null;
}
